// extracted by mini-css-extract-plugin
export default {"spacer":"OdXBP"};